import React from "react";
import { DownOutlined } from "@ant-design/icons";

import { Dropdown, Menu } from "antd";

import { quoteStatus } from "./const";

const MenuOptions = (props) => (
    <Menu onClick={props.onUpdateStatus} theme="dark">
        {quoteStatus
            .filter((e) => e.selectable)
            .map((e) => (
                <Menu.Item key={e.key} icon={e.ico}>
                    {e.name}
                </Menu.Item>
            ))}
    </Menu>
);

const StatusDropdown = (props) => {
    return (
        <Dropdown.Button
            size="small"
            overlay={<MenuOptions {...props} />}
            icon={<DownOutlined />}
            disabled={props.disabled}
            trigger={["click"]}
        >
            {props.status}
        </Dropdown.Button>
    );
};

export default StatusDropdown;
